import { useContext } from "react";
import {
  rulesByOneTwoThree,
  rulesByNineTenEleven,
  rulesByFiveSeven,
  rulesBySix,
  rulesByeight,
  rulesByThirteen,
  rulesBySeventeen,
  rulesByTwenty,
  useRulesBy18,
  useRulesBy16,
  useRulesBy21,
  useRulesBy23,
  useRulesBy12,
  useRulesBy25,
  useRulesBy55,
} from "./ruleByTypes";
import { useRulesBy14 } from "./ruleByTypes/rulesBy-14";
import { useRulesBy22 } from "./ruleByTypes/rulesBy-22";
import { useRulesBy24 } from "./ruleByTypes/rulesBy-24";
import { AuthContext } from "context/context";
import {
  isCancelacionType,
  isTipoEndosoAvailable,
  TIPO_DATOS_FISCALES,
  TIPO_CANCELACION_MASIVA,
} from "shared/utils/endosoTypes";

export const useSubmitData = () => {
  const { handleSubmit18 } = useRulesBy18();
  const { rulesByTwelve } = useRulesBy12();
  const { rulesByFourteen } = useRulesBy14();
  const { rulesBySixteen } = useRulesBy16();
  const { confirmEndoso } = useRulesBy21();
  const { handleConfirm } = useRulesBy22();
  const { handleRows23 } = useRulesBy23();
  const { handleGuardarBorrador: handleGuardarBorrador24 } = useRulesBy24();
  const { handleGuardarBorrador: handleGuardarBorrador25 } = useRulesBy25();
  const { handleGuardarBorrador55 } = useRulesBy55();
  const { bajaAseguramiento } = useContext(AuthContext);
  const handleSubmitData = async (props) => {
    const {
      setSpinner,
      data,
      oldData,
      dataSend,
      setMessage,
      setShowMessage,
      direction,
      formDta,
      endoso,
      setInfoTable,
      setShowButtons,
      showButtons,
      coberturas,
      rowsTable,
      persons,
      setPersons,
      setAlertData,
      setCheckedPersons,
      createMessage,
      history,
    } = props;
    if (!isTipoEndosoAvailable(data.tipend, data.ramo)) {
      setMessage({
        text: "El tipo de endoso seleccionado no esta disponible para el ramo de esta poliza",
        severity: "warning",
      });
      setShowMessage(true);
      return;
    }
    setSpinner(true);
    try {
      if (data.tipend === 1 || data.tipend === 2 || data.tipend === 3) {
        await rulesByOneTwoThree(
          data,
          oldData,
          dataSend,
          setMessage,
          setShowMessage,
          direction,
          formDta,
          endoso,
          setInfoTable,
          setShowButtons,
          showButtons
        );
      }
      if (
        data.tipend === 9 ||
        data.tipend === 10 ||
        data.tipend === 11 ||
        data.tipend === 19
      ) {
        await rulesByNineTenEleven(
          data,
          oldData,
          dataSend,
          setMessage,
          setShowMessage,
          formDta,
          endoso,
          setInfoTable,
          setShowButtons,
          showButtons
        );
      }
      if (isCancelacionType(data.tipend) || data.tipend === 7) {
        await rulesByFiveSeven(
          data,
          oldData,
          dataSend,
          setMessage,
          setShowMessage,
          formDta,
          endoso,
          setInfoTable,
          setShowButtons,
          showButtons
        );
      }
      if (data.tipend === 6) {
        await rulesBySix(
          data,
          oldData,
          dataSend,
          setMessage,
          setShowMessage,
          formDta,
          endoso,
          setInfoTable,
          setShowButtons,
          showButtons
        );
      }
      if (data.tipend === 8) {
        await rulesByeight(
          data,
          setMessage,
          setShowMessage,
          formDta,
          endoso,
          setInfoTable,
          setShowButtons,
          showButtons,
          coberturas,
          rowsTable
        );
      }
      if (data.tipend === 12) {
        const solicitud = formDta.noSolicitud;
        await rulesByTwelve(
          solicitud,
          data,
          setMessage,
          setShowMessage,
          formDta,
          setAlertData,
          dataSend
        );
      }
      if (data.tipend === 13 || data.tipend === 15) {
        await rulesByThirteen(
          data,
          setMessage,
          setShowMessage,
          formDta,
          endoso,
          setShowButtons,
          showButtons,
          persons,
          setPersons,
          history,
          bajaAseguramiento
        );
      }
      if (data.tipend === 14) {
        await rulesByFourteen(data, formDta, persons, setPersons);
      }
      if (data.tipend === 21) {
        await confirmEndoso(formDta.noSolicitud);
      }
      if (data.tipend === 22) {
        await handleConfirm();
      }
      if (data.tipend === 23) {
        await handleRows23();
      }
      if (data.tipend === 16) {
        const info = { ...data, solicitud: formDta.noSolicitud };

        await rulesBySixteen(
          info,
          createMessage,
          dataSend,
          setShowButtons,
          showButtons
        );
      }
      if (data.tipend === 17) {
        await rulesBySeventeen(
          data,
          setMessage,
          setShowMessage,
          formDta,
          setShowButtons,
          showButtons,
          persons,
          setPersons,
          setAlertData,
          setCheckedPersons
        );
      }
      if (data.tipend === 20) {
        await rulesByTwenty(
          dataSend,
          data,
          formDta,
          setMessage,
          setShowMessage,
          showButtons,
          setShowButtons
        );
      }
      if (data.tipend === 18) {
        await handleSubmit18(data);
      }
      if (data.tipend === 24) {
        await handleGuardarBorrador24();
      }
      if (data.tipend === TIPO_DATOS_FISCALES) {
        await handleGuardarBorrador25(dataSend);
      }
      if (Number(data.tipend) === TIPO_CANCELACION_MASIVA) {
        await handleGuardarBorrador55(
          data,
          createMessage,
          formDta,
          setShowButtons,
          showButtons
        );
      }

    } finally {
      setSpinner(false);
    }
  };

  return { handleSubmitData };
};
